export default "__VITE_ASSET__a97667c3__"